var SORT_TYPE = /* @__PURE__ */ ((SORT_TYPE2) => {
  SORT_TYPE2["SORT_BY_UNSPECIFIED"] = "SORT_BY_UNSPECIFIED";
  SORT_TYPE2["SORT_BY_PUBLISH_AT"] = "SORT_BY_PUBLISH_AT";
  SORT_TYPE2["SORT_BY_PRICE"] = "SORT_BY_PRICE";
  SORT_TYPE2["SORT_BY_MOST_VIEW"] = "SORT_BY_MOST_VIEW";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY"] = "SORT_BY_TOP_SALE_QUANTITY";
  SORT_TYPE2["SORT_BY_DISCOUNT_PERCENT"] = "SORT_BY_DISCOUNT_PERCENT";
  SORT_TYPE2["SORT_BY_MOST_VIEW_3_DAYS"] = "SORT_BY_MOST_VIEW_3_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_7_DAYS"] = "SORT_BY_MOST_VIEW_7_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_30_DAYS"] = "SORT_BY_MOST_VIEW_30_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_90_DAYS"] = "SORT_BY_MOST_VIEW_90_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_3_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_3_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_7_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_7_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_30_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_30_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_90_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_90_DAYS";
  return SORT_TYPE2;
})(SORT_TYPE || {});
var SORT_ORDER = /* @__PURE__ */ ((SORT_ORDER2) => {
  SORT_ORDER2["ORDER_BY_UNSPECIFIED"] = "ORDER_BY_UNSPECIFIED";
  SORT_ORDER2["ORDER_BY_ASCENDING"] = "ORDER_BY_ASCENDING";
  SORT_ORDER2["ORDER_BY_DESCENDING"] = "ORDER_BY_DESCENDING";
  return SORT_ORDER2;
})(SORT_ORDER || {});
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});

export { SORT_ORDER, SORT_TYPE, SOURCE_VIDEO };
